/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_Queue_PoInputs */

const en_scene_backstage_queue_po = /** @type {(inputs: Scene_Backstage_Queue_PoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders to approve`)
};

/**
* | output |
* | --- |
* | "Purchase orders to approve" |
*
* @param {Scene_Backstage_Queue_PoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_queue_po = /** @type {((inputs?: Scene_Backstage_Queue_PoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_Queue_PoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_queue_po(inputs)
});